import React from 'react';
import { Box } from 'src/components/Box';
import { Card, CardContent, CardMedia } from 'src/components/Card';
import { Typography } from 'src/components/Typography';
import { Video } from 'src/models/video/_types';

interface GroupVideoCardProps {
  video: Video;
  onVideoClick: (video: Video) => void;
}

export const GroupVideoCard: React.FC<GroupVideoCardProps> = ({
  video,
  onVideoClick,
}) => {
  const handleClick = () => {
    onVideoClick(video);
  };

  return (
    <Card
      sx={{
        cursor: 'pointer',
        display: 'inline-block',
        margin: '0 0 16px',
        width: '100%',
        '&:hover': {
          elevation: 4,
        },
      }}
      onClick={handleClick}
    >
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          image={
            video.largeThumbnailUrl ||
            video.thumbnailUrl ||
            '/placeholder-video.jpg'
          }
          alt={video.name}
          sx={{
            aspectRatio: '16 / 9',
            objectFit: 'cover',
          }}
        />
        {/* Play button overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '24px',
          }}
        >
          ▶
        </Box>
      </Box>
      <CardContent>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 'medium',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {video.name}
        </Typography>
        {video.description && (
          <Typography variant="body1" sx={{ mt: 1 }}>
            {video.description}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};
